/**************************************************
 * Nombre:       Seccion_Retiros
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_MONEDA,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useContext, useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {ESTADOMOVIMIENTOS, ESTADOSUSUARIOS} from "../../Constantes";
import {where} from "firebase/firestore";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import Dialogo_Retiro from "../Dialogos/Dialogo_Retiro";
import {usuarioContext} from "../../App";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";


const Seccion_Retiros = () => {
    const cData = useContext(usuarioContext)
    const [wheres, setWheres] = useState([where('tipo', '==', 'Retiro'), where('idUsuario', '==', 'none')]);
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'movimientos', wheres})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Retiro,
        titulo: 'Detalles del retiro',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }


    useEffect(() => {

        if (cData.usuario && cData.usuario.id) {

            let w = [where('tipo', '==', 'Retiro'),where('idUsuario', '==', cData.usuario.id)]
            setWheres(w)

        }


    },[cData])
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de retiros'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Retiros

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Fecha y Num',
        direccion: 'left',
        propiedades: ['consecutivo', 'nombreBolsillo'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Tipo',
        direccion: 'left',
        propiedad: 'tipo',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Valor',
        direccion: 'left',
        propiedad: 'valor',
        tipo: CASILLA_MONEDA

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOMOVIMIENTOS
    },


]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]